import { render, staticRenderFns } from "./MapCharacterPiece.vue?vue&type=template&id=56fd5986&scoped=true&lang=pug&"
import script from "./MapCharacterPiece.vue?vue&type=script&lang=js&"
export * from "./MapCharacterPiece.vue?vue&type=script&lang=js&"
import style0 from "./MapCharacterPiece.vue?vue&type=style&index=0&id=56fd5986&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd5986",
  null
  
)

component.options.__file = "MapCharacterPiece.vue"
export default component.exports